
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { BetViewMixin } from './mixin'

@Options({})
export default class PcBetView extends Mixins(BetViewMixin) { }
